<div id="loding" [ngClass]="{ 'loding-hide': lodingImage }">
  <img src="assets/img/loding.gif" />
</div>

<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12 headboxes">
        <div class="card p-0">
          <div class="card-block p-0">
            <div
              class="heading-box"
              style="background-image: url(assets/img/faq.png)"
            >
              <div class="row align-items-center">
                <div class="col-md-3">
                  <div class="pagename">
                    <h3 class="card-title">Email Service</h3>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="total-count">
                    <h5 class="m-0">Total</h5>
                    <h2>{{ emailServiceTotal ? emailServiceTotal : 0 }}</h2>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="d-flex align-items-center justify-content-end">
                    <div class="col-md-3">
                      <div class="excel">
                        <button
                          type="button"
                          class="btn btn-primary addbtn"
                          (click)="exportToExcel()"
                        >
                          <i class="fa fa-file-excel-o"></i>&nbsp; Export
                        </button>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="addbtn">
                        <button
                          id="add_btn"
                          type="button"
                          class="btn btn-primary addbtn"
                          (click)="open(content)"
                          style="float: right"
                        >
                          Add Email Service
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="card">
            <div class="card-block">
              <div class="table-responsive">
                <table
                  datatable
                  id="emailServiceTable"
                  [dtOptions]="dtOptions"
                  [dtTrigger]="dtTrigger"
                  class="table ad_table"
                  width="auto !important;"
                >
                  <thead>
                    <tr>
                      <th style="white-space: nowrap">#Sl</th>
                      <th style="white-space: nowrap">Mailer Id</th>
                      <th
                        style="
                          max-width: 400px;
                          min-width: 180px;
                          width: auto !important;
                        "
                      >
                        Title
                      </th>
                      <th
                        style="
                          max-width: 400px;
                          min-width: 250px;
                          width: auto !important;
                        "
                      >
                        Subject
                      </th>
                      <th
                        style="
                          max-width: 400px;
                          min-width: 180px;
                          width: auto !important ;
                        "
                      >
                        Template Name
                      </th>
                      <th
                        style="
                          max-width: 400px;
                          min-width: 180px;
                          width: auto !important ;
                        "
                      >
                        Schedule Date
                      </th>
                      <th style="white-space: nowrap">Schedule By</th>
                      <th style="white-space: nowrap">Scheduled to Mentee</th>
                      <th style="white-space: nowrap">Scheduled to Mentor</th>
                      <th style="white-space: nowrap">Scheduled to Partner</th>
                      <th style="white-space: nowrap">Total</th>
                      <th style="white-space: nowrap">Pending</th>
                      <th style="white-space: nowrap">Success</th>
                      <th style="white-space: nowrap">Error</th>
                      <th style="white-space: nowrap">Stopped</th>
                      <th style="white-space: nowrap">Excel Count</th>
                      <th style="white-space: nowrap">Status</th>
                      <th style="white-space: nowrap">Action</th>
                    </tr>
                  </thead>

                  <tbody *ngIf="emailServiceListing?.length != 0">
                    <tr
                      *ngFor="let item of emailServiceListing; let i = index"
                      [attr.data-index]="i"
                    >
                      <td>{{ getRowNumber(i) }}</td>
                      <td>
                        {{ item.id }}<span *ngIf="item.parent_route">-</span
                        >{{ item.parent_route }}
                      </td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.subject }}</td>
                      <td>{{ item.template_name }}</td>
                      <td>{{ formatDateTime(item.schedule_date) }}</td>
                      <td>{{ item.schedule_by }}</td>
                      <td>{{ item.mentee_count }}</td>
                      <td>{{ item.mentor_count }}</td>
                      <td>{{ item.partner_count }}</td>
                      <td>{{ item.total_count }}</td>
                      <td>{{ item.pending_and_inprogress_count }}</td>
                      <td>{{ item.success_count }}</td>
                      <td>{{ item.invalid_email_and_error_count }}</td>
                      <td>{{ item.stopped_count }}</td>
                      <td>{{ item.excel_count }}</td>
                      <td>
                        <label class="switch">
                          <input
                            type="checkbox"
                            class="status-toggle"
                            [attr.data-id]="item.id"
                            [checked]="item.status === '1'"
                            (change)="delete(item)"
                          />
                          <span class="slider round"></span>
                        </label>
                      </td>
                      <td class="action">
                        <div style="display: flex">
                          <button
                            type="button"
                            class="btn text-dark btn-sm rounded bg-light"
                            (click)="onEdit(content, item.id)"
                          >
                            <i class="fa fa-edit"></i></button
                          >&nbsp;

                          <button
                            type="button"
                            class="btn text-dark btn-sm rounded bg-light"
                            (click)="onDuplicate(content, item.id)"
                          >
                            <i class="fa fa-clone"></i></button
                          >&nbsp;

                          <button
                            type="button"
                            class="btn text-dark btn-sm rounded bg-light"
                            (click)="onRefresh(item.id)"
                          >
                            <i
                              *ngIf="!item.isRefreshing"
                              class="fa fa-refresh"
                            ></i>
                            <i
                              *ngIf="item.isRefreshing"
                              class="fa fa-spinner fa-spin"
                            ></i></button
                          >&nbsp;
                        </div>
                      </td>
                    </tr>
                  </tbody>

                  <tbody *ngIf="emailServiceListing?.length == 0">
                    <tr>
                      <td colspan="17" class="no-data-available text-center">
                        No data available!
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #content let-c="close" let-d="dismiss" id="role-add">
        <div class="modal-info" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">{{ modalTitle }}</h4>
              <button
                type="button"
                class="close"
                aria-label="Close"
                (click)="d('Cross click')"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <alert>
                <div class="alert alert-danger"><a class="close">×</a></div>
              </alert>
              <form [formGroup]="TempMailForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                  <label for="title" class="col-md-12 col-form-label px-0"
                    >Title <span>*</span></label
                  >
                  <div class="col-md-12 px-0">
                    <input
                      class="form-control"
                      type="text"
                      id="title"
                      formControlName="title"
                    />
                    <small *ngIf="isFieldInvalid('title')" class="alert-block">
                      Title is required
                    </small>
                  </div>
                </div>

                <div class="form-group mt-6">
                  <label for="subject" class="col-md-12 px-0 col-form-label"
                    >Subject <span>*</span></label
                  >
                  <div class="col-md-12 px-0">
                    <input
                      class="form-control"
                      type="text"
                      id="subject"
                      formControlName="subject"
                    />
                    <small
                      *ngIf="isFieldInvalid('subject')"
                      class="alert-block"
                    >
                      Subject is required
                    </small>
                  </div>
                </div>

                <div class="form-group mt-3">
                  <label
                    for="templateSelect"
                    class="col-md-12 px-0 col-form-label"
                    >Templates</label
                  >
                  <div class="col-md-12 px-0">
                    <select
                      id="templateSelect"
                      formControlName="templates"
                      class="form-control"
                      (change)="onTemplateSelect($event)"
                    >
                      <option value="" disabled>Select Template</option>
                      <option
                        *ngFor="let temp of templates; let i = index"
                        [value]="i"
                      >
                        {{ temp.title }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group mt-3">
                  <label for="title" class="col-md-12 px-0 col-form-label"
                    >Body <span>*</span></label
                  >
                  <ejs-richtexteditor
                    #rteInstance
                    [insertImageSettings]="imageSettings"
                    [toolbarSettings]="toolbarSettings"
                    formControlName="body"
                    (created)="onRteCreated()"
                  ></ejs-richtexteditor>
                  <small *ngIf="isFieldInvalid('body')" class="alert-block">
                    Body is required
                  </small>
                </div>

                <div class="form-group mt-3">
                  <label>
                    <input type="checkbox" formControlName="isTestEmailMode" />
                    Send as Test Email
                  </label>
                </div>

                <div *ngIf="!TempMailForm.value.isTestEmailMode">
                  <div class="form-group mt-3">
                    <label class="col-md-12 col-form-label px-0"
                      >Choose Recipients<span>*</span></label
                    >
                    <div class="col-md-10 px-0">
                      <div class="table-responsive no-border">
                        <table class="table mb-0">
                          <tbody>
                            <tr class="row-design">
                              <td style="width: auto">Mentee</td>
                              <td style="width: 20%">
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    formControlName="mentee_type"
                                  />
                                  <span class="slider round"></span>
                                </label>
                              </td>
                              <td style="width: auto">To all</td>
                              <td style="width: auto">
                                <label class="switch color-switch">
                                  <input
                                    type="checkbox"
                                    formControlName="mentee_to_all"
                                    disabled="!TempMailForm.get('mentee_type').value"
                                  />
                                  <span class="slider round"></span>
                                </label>
                              </td>
                              <td>To verified only</td>
                              <td
                                style="
                                  display: flex;
                                  align-items: end;
                                  vertical-align: middle;
                                  justify-content: end;
                                "
                              >
                                <div
                                  class="d-flex justify-content-between align-items-center"
                                >
                                  <label class="mx-3 d-flex align-items-center">
                                    <input
                                      type="radio"
                                      formControlName="mentee_business_type"
                                      value="ALL"
                                    />

                                    &nbsp;&nbsp;All
                                  </label>
                                  <label class="mx-3 d-flex align-items-center">
                                    <input
                                      type="radio"
                                      formControlName="mentee_business_type"
                                      value="A"
                                    />
                                    &nbsp;&nbsp;Aspiring
                                  </label>
                                  <label class="mx-3 d-flex align-items-center">
                                    <input
                                      type="radio"
                                      formControlName="mentee_business_type"
                                      value="E"
                                    />
                                    &nbsp;&nbsp;Existing
                                  </label>
                                </div>
                              </td>
                            </tr>

                            <tr class="row-design">
                              <td style="width: auto">Mentor</td>
                              <td style="width: 20%">
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    formControlName="mentor_type"
                                  />
                                  <span class="slider round"></span>
                                </label>
                              </td>
                              <td style="width: auto">To all</td>
                              <td style="width: auto">
                                <label class="switch color-switch">
                                  <input
                                    type="checkbox"
                                    formControlName="mentor_to_all"
                                    disabled="!TempMailForm.get('mentor_type').value"
                                  />
                                  <span class="slider round"></span>
                                </label>
                              </td>
                              <td>To approved only</td>
                              <td></td>
                            </tr>

                            <tr>
                              <td style="width: auto">Partner</td>
                              <td style="width: 20%">
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    formControlName="partner_type"
                                  />
                                  <span class="slider round"></span>
                                </label>
                              </td>
                              <td style="width: auto">To all</td>
                              <td style="width: auto">
                                <label class="switch color-switch">
                                  <input
                                    type="checkbox"
                                    formControlName="partner_to_all"
                                    disabled="!TempMailForm.get('partner_type').value"
                                  />
                                  <span class="slider round"></span>
                                </label>
                              </td>
                              <td>To approved only</td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <small
                    *ngIf="
                      isSubmitted &&
                      TempMailForm.hasError('noRecipient') &&
                      TempMailForm.hasError('missingCheckboxes')
                    "
                    class="alert-block"
                  >
                    Select at least one recipient type (Mentee, Mentor, Partner)
                    or enter Specific Emails.
                  </small>

                  <div class="form-group mt-3">
                    <label class="col-md-12 col-form-label px-0"
                      >Email Delivery Settings <span>*</span></label
                    >
                    <div class="col-md-12 px-0">
                      <label class="me-3">
                        <input
                          type="radio"
                          formControlName="schedule_type"
                          value="now"
                          name="schedule_type"
                        />
                        Now
                      </label>
                      &nbsp;&nbsp;&nbsp;
                      <label class="me-3">
                        <input
                          type="radio"
                          formControlName="schedule_type"
                          value="schedule"
                          name="schedule_type"
                        />
                        Schedule
                      </label>

                      <div
                        class="form-row"
                        *ngIf="TempMailForm.value.schedule_type === 'schedule'"
                      >
                        <div class="form-group col-md-3">
                          <label for="dateInput">Select Schedule Date</label>
                          <input
                            type="date"
                            formControlName="schedule_date"
                            class="form-control"
                            id="dateInput"
                          />
                          <small
                            *ngIf="isFieldInvalid('schedule_date')"
                            class="alert-block"
                          >
                            Schedule date is required
                          </small>
                        </div>
                        <div class="form-group col-md-3">
                          <label for="timeInput">Select Schedule Time</label>
                          <input
                            type="time"
                            formControlName="schedule_time"
                            class="form-control"
                            id="timeInput"
                          />
                          <small
                            *ngIf="isFieldInvalid('schedule_time')"
                            class="alert-block"
                          >
                            Schedule time is required
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group mt-3">
                    <label
                      for="specificEmails"
                      class="col-md-12 col-form-label px-0"
                      >Specific Emails <span>*</span></label
                    >
                    <div class="col-md-12 px-0">
                      <textarea
                        id="specificEmails"
                        class="form-control"
                        rows="3"
                        formControlName="specificEmails"
                        placeholder="Enter comma separated emails here (e.g., test@example.com, another@test.com)"
                      >
                      </textarea>
                      <small
                        *ngIf="
                          isSubmitted &&
                          TempMailForm.hasError('noRecipient') &&
                          TempMailForm.hasError('missingSpecificEmails')
                        "
                        class="alert-block"
                      >
                        Enter Specific Emails or select at least one recipient
                        type (Mentee, Mentor, Partner).
                      </small>
                      <small
                        *ngIf="
                          TempMailForm.get('specificEmails')?.errors
                            ?.invalidEmails
                        "
                        class="alert-block"
                      >
                        Invalid emails:
                        {{
                          TempMailForm.get(
                            "specificEmails"
                          )?.errors?.invalidEmails.join(", ")
                        }}
                      </small>

                      <small
                        *ngIf="
                          TempMailForm.get('specificEmails')?.errors
                            ?.tooManyEmails &&
                          (TempMailForm.get('specificEmails')?.touched ||
                            isSubmitted)
                        "
                        class="alert-block"
                      >
                        You cannot enter more than 100 email addresses.
                      </small>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="TempMailForm.value.isTestEmailMode"
                  class="form-group mt-3"
                >
                  <label for="testEmail">Test Email <span>*</span></label>
                  <textarea
                    id="testEmail"
                    class="form-control"
                    formControlName="test_email"
                    placeholder="Enter single or comma-separated test email addresses (e.g., test@example.com, another@test.com)"
                  ></textarea>
                  <small
                    *ngIf="
                      TempMailForm.get('test_email')?.hasError('required') &&
                      (TempMailForm.get('test_email')?.touched || isSubmitted)
                    "
                    class="alert-block"
                  >
                    At least one test email is required
                  </small>
                  <small
                    *ngIf="
                      TempMailForm.get('test_email')?.errors?.invalidEmails
                    "
                    class="alert-block"
                  >
                    Invalid emails:
                    {{
                      TempMailForm.get(
                        "test_email"
                      )?.errors?.invalidEmails.join(", ")
                    }}
                  </small>

                  <small
                    *ngIf="
                      TempMailForm.get('test_email')?.errors?.tooManyEmails &&
                      (TempMailForm.get('test_email')?.touched || isSubmitted)
                    "
                    class="alert-block"
                  >
                    You cannot enter more than 100 email addresses.
                  </small>
                </div>

                <div class="d-flex w-50 justify-content-between">
                  <div class="form-group mt-3">
                    <label>Bulk Attachment</label>
                    <td style="width: auto">No</td>

                    <td style="width: auto">
                      <label class="switch">
                        <input
                          type="checkbox"
                          [checked]="
                            TempMailForm.get('is_excel')?.value === 'Y'
                          "
                          (change)="onExcelChange($event)"
                        />
                        <span class="slider round"></span>
                      </label>
                    </td>
                    <td>Yes</td>
                  </div>

                  <div
                    *ngIf="TempMailForm.get('is_excel')?.value === 'Y'"
                    class="mt-4"
                  >
                    <div>
                      <label
                        style="
                          border: 1px solid black;
                          padding: 4px;
                          margin-top: 15px;
                        "
                      >
                        {{ isEditExcel ? "Update File" : "Choose File" }}
                        <input
                          type="file"
                          accept=".csv"
                          (change)="onFileSelected($event)"
                          hidden
                        />
                      </label>

                      <span *ngIf="selectedFileName" class="ml-2 text">
                        {{ selectedFileName }}
                      </span>
                    </div>

                    <div>
                      <a
                        style="color: #dc6273"
                        href="../../assets/sample/email.csv"
                        download
                        >Download Sample CSV</a
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 mt-3">
                    <label>Add Attachment</label>
                    <td style="width: auto">No</td>

                    <td style="width: auto">
                      <label class="switch">
                        <input
                          type="checkbox"
                          [checked]="
                            TempMailForm.get('is_attachment')?.value === 'Y'
                          "
                          (change)="onAttachmentChange($event)"
                        />
                        <span class="slider round"></span>
                      </label>
                    </td>
                    <td>Yes</td>
                  </div>
                  <div class="col-md-12">
                    <div
                      *ngIf="TempMailForm.get('is_attachment')?.value === 'Y'"
                      class="row"
                    >
                      <div class="form-group col-md-3">
                        <label>Attachment1 </label>

                        <ng-container>
                          <input
                            type="file"
                            (change)="onAttachmentSelected1($event)"
                            accept="image/*,video/*,.pdf,.doc,.docx,.ppt,.pptx"
                            class="form-control"
                          />
                          <small *ngIf="fileSizeError1" class="text-danger"
                            >File too large (max 20 MB)</small
                          >
                        </ng-container>

                        <ng-container
                          *ngIf="
                            currentAttachment1 ||
                            (isEditMode && hasExistingAttachment)
                          "
                        >
                        </ng-container>

                        <div
                          class="small mt-1 text-truncate"
                          style="max-width: 250px"
                        >
                          {{ currentAttachment1?.fileName }}
                        </div>

                        <div
                          *ngIf="
                            getFileIconType(currentAttachment1) === 'image'
                          "
                          class="mt-2 position-relative text-center"
                        >
                          <img
                            style="
                              height: 70px;
                              width: 70px;
                              padding: 0;
                              margin: auto;
                            "
                            class="img-thumbnail mb-3"
                            *ngIf="this.currentAttachment1.base64 != ''"
                            [src]="this.currentAttachment1.base64"
                          />
                          <i
                            (click)="removeAttachment1()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              font-size: 20px;
                              cursor: pointer;
                              left: 160px;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <div
                          *ngIf="
                            getFileIconType(currentAttachment1) === 'video'
                          "
                          class="mt-2 position-relative"
                        >
                          <video
                            [src]="this.currentAttachment1.base64"
                            controls
                            class="card-img-top"
                            style="object-fit: cover; height: 100px"
                          ></video>
                          <i
                            (click)="removeAttachment1()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 100%;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <div
                          *ngIf="
                            getFileIconType(currentAttachment1) === 'powerpoint'
                          "
                          class="mt-2 position-relative text-center"
                        >
                          <i
                            class="fa fa-file-powerpoint-o"
                            style="font-size: 65px"
                          ></i>

                          <i
                            (click)="removeAttachment1()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 152px;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <div
                          *ngIf="getFileIconType(currentAttachment1) === 'pdf'"
                          class="mt-2 position-relative text-center"
                        >
                          <i class="fa fa-file" style="font-size: 65px"></i>
                          <i
                            (click)="removeAttachment1()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 152px;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <!-- Word Document (.doc / .docx) -->
                        <div
                          *ngIf="getFileIconType(currentAttachment1) === 'word'"
                          class="mt-2 position-relative text-center"
                        >
                          <i
                            class="fa fa-file-word-o"
                            style="font-size: 65px"
                          ></i>

                          <i
                            (click)="removeAttachment1()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 152px;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <!-- Excel (.xls / .xlsx) -->
                        <div
                          *ngIf="
                            getFileIconType(currentAttachment1) === 'excel'
                          "
                          class="mt-2 position-relative text-center"
                        >
                          <i
                            class="fa fa-file-excel-o"
                            style="font-size: 65px"
                          ></i>
                          <div
                            class="small mt-1 text-truncate"
                            style="max-width: 250px"
                          >
                            {{ currentAttachment1?.fileName }}
                          </div>
                          <i
                            (click)="removeAttachment1()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              right: 0;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <!-- Text / Generic File -->
                        <div
                          *ngIf="getFileIconType(currentAttachment1) === 'text'"
                          class="mt-2 position-relative text-center"
                        >
                          <i class="fa fa-file-o" style="font-size: 65px"></i>
                          <div
                            class="small mt-1 text-truncate"
                            style="max-width: 250px"
                          >
                            {{ currentAttachment1?.fileName }}
                          </div>
                          <i
                            (click)="removeAttachment1()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              right: 0;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>
                      </div>

                      <div class="form-group col-md-3">
                        <label>Attachment2 </label>

                        <ng-container>
                          <input
                            type="file"
                            (change)="onAttachmentSelected2($event)"
                            accept="image/*,video/*,.pdf,.doc,.docx,.ppt,.pptx"
                            class="form-control"
                          />
                          <small *ngIf="fileSizeError2" class="text-danger"
                            >File too large (max 20 MB)</small
                          >
                        </ng-container>

                        <div
                          class="small mt-1 text-truncate"
                          style="max-width: 250px"
                        >
                          {{ currentAttachment2?.fileName }}
                        </div>

                        <div
                          *ngIf="
                            getFileIconType(currentAttachment2) === 'image'
                          "
                          class="mt-2 position-relative text-center"
                        >
                          <img
                            style="height: 70px; width: 70px; padding: 0"
                            class="img-thumbnail mb-3"
                            *ngIf="this.currentAttachment2.base64 != ''"
                            [src]="this.currentAttachment2.base64"
                          />
                          <i
                            (click)="removeAttachment2()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="top: -6px; font-size: 20px; cursor: pointer"
                            title="Remove"
                          ></i>
                        </div>

                        <div
                          *ngIf="
                            getFileIconType(currentAttachment2) === 'powerpoint'
                          "
                          class="mt-2 position-relative text-center"
                        >
                          <i
                            class="fa fa-file-powerpoint-o"
                            style="font-size: 65px"
                          ></i>

                          <i
                            (click)="removeAttachment2()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 152px;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <div
                          *ngIf="
                            getFileIconType(currentAttachment2) === 'video'
                          "
                          class="mt-2 position-relative"
                        >
                          <video
                            [src]="this.currentAttachment2.base64"
                            controls
                            class="card-img-top"
                            style="object-fit: cover; height: 100px"
                          ></video>
                          <i
                            (click)="removeAttachment2()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 100%;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <div
                          *ngIf="getFileIconType(currentAttachment2) === 'pdf'"
                          class="mt-2 position-relative text-center"
                        >
                          <i class="fa fa-file" style="font-size: 65px"></i>
                          <i
                            (click)="removeAttachment2()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 152px;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <!-- Word Document (.doc / .docx) -->
                        <div
                          *ngIf="getFileIconType(currentAttachment2) === 'word'"
                          class="mt-2 position-relative text-center"
                        >
                          <i
                            class="fa fa-file-word-o"
                            style="font-size: 65px"
                          ></i>

                          <i
                            (click)="removeAttachment2()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 152px;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <!-- Excel (.xls / .xlsx) -->
                        <div
                          *ngIf="
                            getFileIconType(currentAttachment2) === 'excel'
                          "
                          class="mt-2 position-relative text-center"
                        >
                          <i
                            class="fa fa-file-excel-o"
                            style="font-size: 65px"
                          ></i>
                          <div
                            class="small mt-1 text-truncate"
                            style="max-width: 250px"
                          >
                            {{ currentAttachment2.fileName }}
                          </div>
                          <i
                            (click)="removeAttachment2()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              right: 0;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <!-- Text / Generic File -->
                        <div
                          *ngIf="getFileIconType(currentAttachment2) === 'text'"
                          class="mt-2 position-relative text-center"
                        >
                          <i class="fa fa-file-o" style="font-size: 65px"></i>
                          <div
                            class="small mt-1 text-truncate"
                            style="max-width: 250px"
                          >
                            {{ currentAttachment2.fileName }}
                          </div>
                          <i
                            (click)="removeAttachment2()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              right: 0;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>
                      </div>

                      <div class="form-group col-md-3">
                        <label>Attachment3 </label>

                        <ng-container>
                          <input
                            type="file"
                            (change)="onAttachmentSelected3($event)"
                            accept="image/*,video/*,.pdf,.doc,.docx,.ppt,.pptx"
                            class="form-control"
                          />
                          <small *ngIf="fileSizeError3" class="text-danger"
                            >File too large (max 20 MB)</small
                          >
                        </ng-container>

                        <div
                          class="small mt-1 text-truncate"
                          style="max-width: 250px"
                        >
                          {{ currentAttachment3?.fileName }}
                        </div>

                        <div
                          *ngIf="
                            getFileIconType(currentAttachment3) === 'image'
                          "
                          class="mt-2 position-relative text-center"
                        >
                          <img
                            style="height: 70px; width: 70px; padding: 0"
                            class="img-thumbnail mb-3"
                            *ngIf="this.currentAttachment3.base64 != ''"
                            [src]="this.currentAttachment3.base64"
                          />

                          <i
                            (click)="removeAttachment3()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              font-size: 20px;
                              cursor: pointer;
                              left: 162px;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <div
                          *ngIf="
                            getFileIconType(currentAttachment3) === 'powerpoint'
                          "
                          class="mt-2 position-relative text-center"
                        >
                          <i
                            class="fa fa-file-powerpoint-o"
                            style="font-size: 65px"
                          ></i>

                          <i
                            (click)="removeAttachment3()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 152px;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <div
                          *ngIf="
                            getFileIconType(currentAttachment3) === 'video'
                          "
                          class="mt-2 position-relative"
                        >
                          <video
                            [src]="this.currentAttachment3.base64"
                            controls
                            class="card-img-top"
                            style="object-fit: cover; height: 100px"
                          ></video>
                          <i
                            (click)="removeAttachment3()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 100%;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <div
                          *ngIf="getFileIconType(currentAttachment3) === 'pdf'"
                          class="mt-2 position-relative text-center"
                        >
                          <i class="fa fa-file" style="font-size: 65px"></i>
                          <i
                            (click)="removeAttachment3()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 152px;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <!-- Word Document (.doc / .docx) -->
                        <div
                          *ngIf="getFileIconType(currentAttachment3) === 'word'"
                          class="mt-2 position-relative text-center"
                        >
                          <i
                            class="fa fa-file-word-o"
                            style="font-size: 65px"
                          ></i>

                          <i
                            (click)="removeAttachment3()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 152px;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <!-- Excel (.xls / .xlsx) -->
                        <div
                          *ngIf="
                            getFileIconType(currentAttachment3) === 'excel'
                          "
                          class="mt-2 position-relative text-center"
                        >
                          <i
                            class="fa fa-file-excel-o"
                            style="font-size: 65px"
                          ></i>
                          <div
                            class="small mt-1 text-truncate"
                            style="max-width: 250px"
                          >
                            {{ currentAttachment3.fileName }}
                          </div>
                          <i
                            (click)="removeAttachment3()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              right: 0;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <!-- Text / Generic File -->
                        <div
                          *ngIf="getFileIconType(currentAttachment3) === 'text'"
                          class="mt-2 position-relative text-center"
                        >
                          <i class="fa fa-file-o" style="font-size: 65px"></i>
                          <div
                            class="small mt-1 text-truncate"
                            style="max-width: 250px"
                          >
                            {{ currentAttachment3.fileName }}
                          </div>
                          <i
                            (click)="removeAttachment3()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              right: 0;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>
                      </div>

                      <div class="form-group col-md-3">
                        <label>Attachment4 </label>

                        <ng-container>
                          <input
                            type="file"
                            (change)="onAttachmentSelected4($event)"
                            accept="image/*,video/*,.pdf,.doc,.docx,.ppt,.pptx"
                            class="form-control"
                          />
                          <small *ngIf="fileSizeError4" class="text-danger"
                            >File too large (max 20 MB)</small
                          >
                        </ng-container>

                        <div
                          class="small mt-1 text-truncate"
                          style="max-width: 250px"
                        >
                          {{ currentAttachment4?.fileName }}
                        </div>

                        <div
                          *ngIf="
                            getFileIconType(currentAttachment4) === 'image'
                          "
                          class="mt-2 position-relative text-center"
                        >
                          <img
                            style="
                              height: 70px;
                              width: 70px;
                              padding: 0;
                              left: 162px;
                            "
                            class="img-thumbnail mb-3"
                            *ngIf="this.currentAttachment4.base64 != ''"
                            [src]="this.currentAttachment4.base64"
                          />
                          <i
                            (click)="removeAttachment4()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="top: -6px; font-size: 20px; cursor: pointer"
                            title="Remove"
                          ></i>
                        </div>

                        <div
                          *ngIf="
                            getFileIconType(currentAttachment4) === 'powerpoint'
                          "
                          class="mt-2 position-relative text-center"
                        >
                          <i
                            class="fa fa-file-powerpoint-o"
                            style="font-size: 65px"
                          ></i>

                          <i
                            (click)="removeAttachment4()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 152px;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <div
                          *ngIf="
                            getFileIconType(currentAttachment4) === 'video'
                          "
                          class="mt-2 position-relative"
                        >
                          <video
                            [src]="this.currentAttachment4.base64"
                            controls
                            class="card-img-top"
                            style="object-fit: cover; height: 100px"
                          ></video>
                          <i
                            (click)="removeAttachment4()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 100%;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <div
                          *ngIf="getFileIconType(currentAttachment4) === 'pdf'"
                          class="mt-2 position-relative text-center"
                        >
                          <i class="fa fa-file" style="font-size: 65px"></i>
                          <i
                            (click)="removeAttachment4()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 152px;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <!-- Word Document (.doc / .docx) -->
                        <div
                          *ngIf="getFileIconType(currentAttachment4) === 'word'"
                          class="mt-2 position-relative text-center"
                        >
                          <i
                            class="fa fa-file-word-o"
                            style="font-size: 65px"
                          ></i>

                          <i
                            (click)="removeAttachment4()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              left: 152px;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <!-- Excel (.xls / .xlsx) -->
                        <div
                          *ngIf="
                            getFileIconType(currentAttachment4) === 'excel'
                          "
                          class="mt-2 position-relative text-center"
                        >
                          <i
                            class="fa fa-file-excel-o"
                            style="font-size: 65px"
                          ></i>
                          <div
                            class="small mt-1 text-truncate"
                            style="max-width: 250px"
                          >
                            {{ currentAttachment4.fileName }}
                          </div>
                          <i
                            (click)="removeAttachment4()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              right: 0;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>

                        <!-- Text / Generic File -->
                        <div
                          *ngIf="getFileIconType(currentAttachment4) === 'text'"
                          class="mt-2 position-relative text-center"
                        >
                          <i class="fa fa-file-o" style="font-size: 65px"></i>
                          <div
                            class="small mt-1 text-truncate"
                            style="max-width: 250px"
                          >
                            {{ currentAttachment4.fileName }}
                          </div>
                          <i
                            (click)="removeAttachment4()"
                            class="fa fa-times-circle text-danger position-absolute"
                            style="
                              top: -6px;
                              right: 0;
                              font-size: 20px;
                              cursor: pointer;
                            "
                            title="Remove"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group mt-3">
                  <label>
                    <input type="checkbox" formControlName="is_published" />
                    Save as Draft
                  </label>
                </div>

                <span class="text-danger" *ngIf="isErrorShow">{{
                  isErrorShow
                }}</span>
                <span class="text-success" *ngIf="isSuccessShow">{{
                  isSuccessShow
                }}</span>
                <small
                  *ngIf="
                    TempMailForm.hasError('attachmentRequired') &&
                    (isSubmitted || TempMailForm.get('is_attachment')?.touched)
                  "
                  class="text-danger d-block mt-1"
                >
                  At least one attachment is required when "Add Attachment" is
                  enabled.</small
                >

                <br />

                <button
                  type="submit"
                  class="btn btn-primary savebtn rounded mt-3"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- Modal Structure -->
  <div
    class="modal fade testemail d-none"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" style="max-width: 500px" role="document"></div>
  </div>
</div>
